import { jwtDecode } from 'jwt-decode';
import { setSessionItemWithExpiry } from './utility';
import { convertMinuteToMiliseconds, APP_CONFIG } from './index';
import { SESSION_STORAGE_KEY } from '../constant/auth.constant';

interface Privilege {
  name: string;
}

interface DecodedToken {
  exp: number;
  review: boolean;
  privileges?: Privilege[];
}

export const accessPrivilegeReview = (newToken: string) => {
  const decoded: DecodedToken = jwtDecode(newToken);
  const review = decoded.review;
  const privilegeNames = decoded.privileges?.map((privilege) => privilege.name) || [];

  const privilegesExpiry = convertMinuteToMiliseconds(Number(APP_CONFIG.PRIVILEGES_EXPIRY));
  setSessionItemWithExpiry(SESSION_STORAGE_KEY.REVIEW, JSON.stringify(review), privilegesExpiry);
  setSessionItemWithExpiry(
    SESSION_STORAGE_KEY.PRIVILEGES,
    JSON.stringify(privilegeNames),
    privilegesExpiry,
  );

  window.dispatchEvent(new Event('privilegesUpdated'));

  return { review, privilegeNames };
};

/**
 * Persist the authenticated user's role in sessionStorage (same expiry window
 * as privileges) so non-component helpers like `getNavigationRoute` can make
 * role-based routing decisions (e.g. route Students to the common landing page).
 *
 * @param role - The role string from the login response (`response.role`)
 */
export const setUserRole = (role: string) => {
  const privilegesExpiry = convertMinuteToMiliseconds(Number(APP_CONFIG.PRIVILEGES_EXPIRY));
  setSessionItemWithExpiry(SESSION_STORAGE_KEY.ROLE, role, privilegesExpiry);
};

export const setTokenExpiry = (newToken: string) => {
  const decoded: DecodedToken = jwtDecode(newToken);
  const expiryTime = decoded.exp * 1000;
  localStorage.setItem('expiryTime', expiryTime.toString());
};

export const isTokenExpired = (): boolean => {
  const expiryTime = localStorage.getItem('expiryTime');
  if (!expiryTime) return true;
  return Date.now() > parseInt(expiryTime, 10);
};
